

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _angular = require('angular');

require('./lib/ui');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/shoppingcart/index');

var _index2 = require('xo-models/src/ppcartMapper/index');

var _index3 = require('xo-models/src/cartButtonParams/index');

var _index4 = require('xo-models/src/inventory/index');

require('xo-ui-components/src/accessibility/directive');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _cartUtil = require('./cartUtil');

var _cartUtil2 = _interopRequireDefault(_cartUtil);

var _cartUiUtil = require('./cartUiUtil');

var _cartUiUtil2 = _interopRequireDefault(_cartUiUtil);

var _customUtil = require('../../js/lib/customUtil.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var sCart = void 0,
    buttonParams = void 0,
    cartItems = void 0,
    cartRequest = void 0,
    checkoutCartDetails = void 0,
    soldoutItems = void 0,
    additionalCharges = void 0,
    checkoutXclickParam = void 0;
var setAdditionalParameters = void 0,
    getShoppingCart = void 0,
    callUpdateCart = void 0,
    callDeleteCart = void 0,
    initiateUpdateQuantity = void 0,
    itemsToUpdate = void 0,
    fallback = void 0,
    prepareCheckout = void 0;
var memberXOButtonScript = void 0,
    guestXOButtonScript = void 0;

exports['default'] = _squid.$Component.extend('$xoShoppingCart', {
    tag: 'xo-shopping-cart-page',
    template: _template2['default'],

    resolve: {
        models: function models() {
            var _this = this;

            if (this.stateChanged) {
                return;
            }

            // TODO: replace this hard coded token with the mayfly Id that will be coming in the url
            var shoppingCartModel = _index.$ShoppingCartModel.instance(_squid.$meta.correlationId);
            var buttonParamsModel = _index3.$CartButtonParamsModel.instance();
            var noUpdateRequired = _uiRouter.$state.params.noUpdateRequired;

            var viewCart = buttonParams.viewCart;
            var buttonDetails = {};
            if (buttonParams) {
                if (buttonParams.buttonItem && buttonParams.buttonItem.items[0] && buttonParams.buttonItem.items[0].customized_info) {
                    buttonDetails.hosted_button_id = buttonParams.buttonItem.items[0].customized_info.hosted_button_id;
                }
                _logger.$logger.info('merchant_id', {
                    merchant_id: buttonParams.merchantId
                });
            }
            buttonDetails['button_type'] = viewCart ? 'view_cart' : 'add_to_cart';
            _logger.$logger.info('button_details', buttonDetails);
            setAdditionalParameters = function setAdditionalParameters(shoppingCart) {
                sCart = $.extend(true, {}, shoppingCart);
                if (shoppingCart) {
                    _this.itemsInCart = $.extend(true, [], shoppingCart.items);
                    cartItems = $.extend(true, [], shoppingCart.items);
                    if (shoppingCart.items && shoppingCart.items[0]) {
                        _this.currencyCode = shoppingCart.items && shoppingCart.items[0].currency;
                    }
                }
                _this.continueShoppingUrl = shoppingCart && shoppingCart.urls && shoppingCart.urls.shopping_url || _this.previousPageUrl;
                var additionalChargesRes = _cartUtil2['default'].validateAndGetAdditionalCharges(sCart);
                if (additionalChargesRes && additionalChargesRes.cartValid) {
                    additionalCharges = $.extend(true, {}, additionalChargesRes.charges);
                    _this.additionalCharges = $.extend(true, {}, additionalChargesRes.charges);
                } else {
                    _logger.$logger.info('cart_invalid', additionalChargesRes);
                    _this.stateChanged = true;
                    return _uiRouter.$state.go('checkout.genericError');
                }
                _logger.$logger.info('additional_parameters', {
                    continue_shopping_url: _this.continueShoppingUrl,
                    additional_charges: additionalCharges
                });
                if (cartItems) {
                    var itemsDetails = cartItems.map(function (item) {
                        return {
                            sku: item.sku,
                            name: item.name
                        };
                    });
                    _logger.$logger.info('items_details', itemsDetails);
                }
            };

            var createShoppingCart = function createShoppingCart(itemFromButton, payeeEmail, visitorId) {
                if (!itemFromButton.total_weight && itemFromButton.items && itemFromButton.items[0] && itemFromButton.items[0].weight) {
                    itemFromButton.total_weight = {
                        'value': '',
                        'unit': itemFromButton.items[0].weight.unit
                    };
                }
                return shoppingCartModel.action('createShoppingCart', {
                    data: {
                        request: itemFromButton
                    },
                    success: function success(result) {
                        setAdditionalParameters(result);
                    },
                    contingencies: {
                        DUPLICATE_REQUEST: function DUPLICATE_REQUEST(err) {
                            _logger.$logger.info('DUPLICATE_REQUEST_error', err);
                            _this.duplicateRequest = true;
                            _this.payeeEmail = payeeEmail;
                            _this.visitorId = visitorId;
                        }
                    }
                });
            };

            getShoppingCart = function getShoppingCart() {
                shoppingCartModel.invalidate();
                return shoppingCartModel.retrieve({
                    params: {
                        payee_email: _this.payeeEmail,
                        visitor_id: _this.visitorId
                    },
                    success: function success(response) {
                        sCart = $.extend(true, {}, response);
                        _this.itemsInCart = $.extend(true, [], response.items);
                        cartItems = $.extend(true, [], response.items);
                        _this.currencyCode = response.items && response.items[0] && response.items[0].currency;
                        _this.continueShoppingUrl = response.urls && response.urls.shopping_url || _this.previousPageUrl;
                        setAdditionalParameters(response);
                    }
                });
            };

            callUpdateCart = function callUpdateCart(shoppingCart) {
                if (!_this.quantityChanged) {
                    _angular.$timeout.cancel(_this.timer);
                    return;
                } else {
                    _this.quantityChanged = false;
                }
                var itemFromButton = buttonParams.buttonItem;
                if (itemFromButton && !itemFromButton.total_weight && !shoppingCart.total_weight && itemFromButton.items && itemFromButton.items[0] && itemFromButton.items[0].weight) {
                    if (shoppingCart.items && shoppingCart.items[0] && shoppingCart.items[0].weight) {
                        shoppingCart.total_weight = {
                            'value': '',
                            'unit': shoppingCart.items[0].weight.unit
                        };
                    } else {
                        shoppingCart.total_weight = {
                            'value': '',
                            'unit': 'lbs'
                        };
                    }
                }
                return shoppingCartModel.action('updateShoppingcart', {
                    data: {
                        id: shoppingCart.id,
                        request: shoppingCart
                    },
                    success: function success(result) {
                        _angular.$timeout.cancel(_this.timer);
                        setAdditionalParameters(result);
                    }
                });
            };

            callDeleteCart = function callDeleteCart(shoppingCart) {
                return shoppingCartModel.action('deleteShoppingcart', {
                    data: {
                        id: shoppingCart.id
                    }
                });
            };

            return buttonParamsModel.retrieve({
                params: {
                    raw_params: _squid.$meta.xclickParams
                },
                success: function success(resp) {
                    var payeeEmail = void 0,
                        visitorId = void 0,
                        shoppingUrl = void 0;
                    _underscore2['default'].forEach(resp, function (param) {
                        if (typeof param === 'string') {
                            var key = param.split('=')[0];
                            var value = param.split('=')[1];
                            if (key === 'merchant_email') {
                                payeeEmail = value;
                            } else if (key === 'visitor_id') {
                                visitorId = value;
                            }
                        }
                    });
                    shoppingUrl = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams)['shopping_url'];
                    shoppingCartModel.invalidate();
                    return _angular.$q.all([shoppingCartModel.retrieve({
                        params: {
                            payee_email: payeeEmail,
                            visitor_id: visitorId
                        },
                        success: function success(response) {
                            if (response.resourceNotFound) {
                                if (viewCart) {
                                    _logger.$logger.info('cart_empty');
                                    _this.stateChanged = true;
                                    _this.continueShoppingUrl = shoppingUrl || _this.previousPageUrl;
                                    _angular.$rootScope.continueShoppingUrl = _this.continueShoppingUrl;
                                    return _uiRouter.$state.go('checkout.emptyCart');
                                } else {
                                    _logger.$logger.info('cart_empty_create_cart');
                                    return createShoppingCart(buttonParams.buttonItem, payeeEmail, visitorId);
                                }
                            } else {
                                sCart = $.extend(true, {}, response);
                                _this.itemsInCart = $.extend(true, [], response.items);
                                cartItems = $.extend(true, [], response.items);
                                _this.currencyCode = response.items && response.items[0] && response.items[0].currency;
                                _this.continueShoppingUrl = response.urls && response.urls.shopping_url || _this.previousPageUrl;
                                if (!viewCart && noUpdateRequired !== 'true') {
                                    _logger.$logger.info('cart_exists_update_cart');
                                    var shoppingcartToUpdate = _cartUtil2['default'].addItemToCart(buttonParams.buttonItem, response);
                                    _this.quantityChanged = true;
                                    return callUpdateCart(shoppingcartToUpdate);
                                } else {
                                    setAdditionalParameters(response);
                                    _logger.$logger.info('cart_exists_show_cart');
                                }
                            }
                        }
                    })]).then(function () {
                        if (_this.duplicateRequest) {
                            return getShoppingCart();
                        }
                    });
                }
            });
        }
    },

    actions: {
        continueShopping: function continueShopping($event) {
            if ($event) {
                $event.preventDefault();
            }

            // TODO: add a util function to do this logic which is in multiple pages now
            if (window.opener && window.opener !== null && !window.opener.closed) {
                _logger.$logger.info('continue_shopping_target_not_self');
                try {
                    window.opener.location.href = this.continueShoppingUrl;
                } catch (err) {
                    _logger.$logger.info('window_opener_location_error', { err: err });
                } finally {
                    self.close();
                }
            } else {
                _logger.$logger.info('continue_shopping_target_self');
                _squid.$util.redirect(this.continueShoppingUrl);
            }
        },
        increment: function increment(index) {
            this.itemsInCart[index].quantity++;
            cartItems[index].quantity = this.itemsInCart[index].quantity;
            this.quantityChanged = true;
            initiateUpdateQuantity();
        },
        decrement: function decrement(index) {
            if (this.itemsInCart[index].quantity > 0) {
                this.itemsInCart[index].quantity--;
                cartItems[index].quantity = this.itemsInCart[index].quantity;
                this.quantityChanged = true;
                initiateUpdateQuantity();
            }
        },
        remove: function remove(index) {
            var _this2 = this;

            this.itemsInCart[index].removed = true;
            cartItems[index].removed = true;
            if (this.currentExpandedDetails === index) {
                this.currentExpandedDetails = undefined;
            }
            var cart = $.extend(true, {}, sCart);
            _cartUiUtil2['default'].setOrderSummaryColor();
            cart.items = itemsToUpdate();
            if (cart.items.length === 0) {
                _logger.$logger.info('all_items_removed');
                this.quantityChanged = false;
                _angular.$q.all([callDeleteCart(cart)]).then(function () {
                    _this2.stateChanged = true;
                    _angular.$rootScope.continueShoppingUrl = _this2.continueShoppingUrl;
                    return _uiRouter.$state.go('checkout.emptyCart');
                });
            } else {
                this.quantityChanged = true;
                (0, _angular.$timeout)(function () {
                    _angular.$q.all([callUpdateCart(cart)]).then(function () {
                        return;
                    });
                }, 500);
            }
        },
        keyUp: function keyUp(event, index) {
            event = event || window.event;
            if (event) {
                // 38 : up arrow, 40: down arrow
                if (event.keyCode === 38) {
                    this.actions.increment(index);
                } else if (event.keyCode === 40) {
                    this.actions.decrement(index);
                }
            }
        },
        checkValidity: function checkValidity(index, oldValue) {
            // allow user to enter only a positive integer
            if (!/^\d*$/.test(this.itemsInCart[index].quantity)) {
                cartItems[index].quantity = this.itemsInCart[index].quantity = oldValue;
            } else if (this.itemsInCart[index].quantity !== '') {
                this.quantityChanged = true;
            } else {
                this.quantityChanged = false;
            }
        },
        showMore: function showMore(index) {
            var _this3 = this;

            var delay = 0;

            if (this.currentExpandedDetails !== index) {
                if (this.currentExpandedDetails !== undefined) {
                    delay = 500;
                    this.actions.showLess(this.currentExpandedDetails);
                }
            }

            (0, _angular.$timeout)(function () {
                if (_this3.itemsInCart[index]) {
                    _this3.itemsInCart[index].showDetails = true;
                    _this3.itemsInCart[index].showExtraText = true;
                } else {
                    _logger.$logger.info('Cannot showMore of item: ', { index: index, itemsCount: _this3.itemsInCart && _this3.itemsInCart.length });
                }
                angular.element('#item' + index + 'name').removeClass('ellipsisEffect');
                angular.element('#item' + index + 'number').removeClass('ellipsisEffect');
                if (angular.element('#item' + index + 'name').hasClass('nowrap')) {
                    angular.element('#item' + index + 'name').removeClass('nowrap');
                }
                if (angular.element('#item' + index + 'number').hasClass('nowrap')) {
                    angular.element('#item' + index + 'number').removeClass('nowrap');
                }
                if (angular.element('#item' + index + 'number').hasClass('hide')) {
                    angular.element('#item' + index + 'number').removeClass('hide');
                }

                _this3.currentExpandedDetails = index;
            }, delay);
        },
        showLess: function showLess(index) {
            if (this.itemsInCart[index]) {
                this.itemsInCart[index].showDetails = false;
                this.itemsInCart[index].showExtraText = false;
            } else {
                _logger.$logger.info('Cannot showMore of item: ', { index: index, itemsCount: this.itemsInCart && this.itemsInCart.length });
            }
            angular.element('#item' + index + 'name').addClass('ellipsisEffect');
            angular.element('#item' + index + 'number').addClass('ellipsisEffect');
            if (this.itemsInCart[index].itemNameLong) {
                angular.element('#item' + index + 'number').addClass('hide');
            }
            (0, _angular.$timeout)(function () {
                angular.element('#item' + index + 'name').addClass('nowrap');
                angular.element('#item' + index + 'number').addClass('nowrap');
            }, 500); // same time duration specified in max-height transition
            this.currentExpandedDetails = undefined;
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            var loadJsButton = function loadJsButton(checkoutType, localeInfo) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.setAttribute('data-merchant', 'PP_ADD_TO_CART');
                script.setAttribute('data-button', 'checkout');
                script.setAttribute('data-type', 'button');
                script.setAttribute('data-size', 'medium');
                script.setAttribute('data-lc', localeInfo);
                script.setAttribute('data-shape', 'pill');
                if (checkoutType === 'member') {
                    script.setAttribute('data-color', 'gold');
                } else {
                    script.setAttribute('data-color', 'silver');
                    script.setAttribute('data-label', _squid.$locale.content.get('shoppingCart.checkoutOut'));
                    script.setAttribute('data-tagline', 'false');
                }
                script.src = 'https://www.paypalobjects.com/api/button.js';
                return script;
            };

            angular.element('.merchantHeader').css('display', 'none');
            var localeInfo = _squid.$locale.lang + '_' + _squid.$locale.country;
            _logger.$logger.info('localeInfo', { country: _squid.$locale.country, lang: _squid.$locale.lang });

            memberXOButtonScript = loadJsButton('member', localeInfo);
            guestXOButtonScript = loadJsButton('guest', localeInfo);

            buttonParams = _cartUtil2['default'].getButtonParams(_squid.$meta.xclickParams);
            this.previousPageUrl = document.referrer;

            this.getCartItemsTotal = function () {
                return _cartUtil2['default'].getCartItemsTotal(_this4.itemsInCart);
            };

            this.getNetTotal = function () {
                var sum = _this4.getCartItemsTotal() || 0;
                _underscore2['default'].forEach(_this4.additionalCharges, function (detail) {
                    if (detail.name === 'discount') {
                        sum -= detail.value;
                    } else {
                        sum += detail.value;
                    }
                });
                return sum;
            };

            this.toggleArrowDirection = function () {
                _this4.expandSummary = !_this4.expandSummary;
                if (_this4.expandSummary) {
                    _this4.orderSummaryMaxHeight = $('.details-expand').prop('scrollHeight');
                }
                (0, _angular.$timeout)(function () {
                    _cartUiUtil2['default'].setOrderSummaryColor();
                }, 500);
            };

            this.getEachItemMaxHeight = function (index) {
                return _cartUiUtil2['default'].getEachItemMaxHeight(_this4.itemsInCart, index);
            };

            this.getItemsMaxHeight = function (index) {
                return _cartUiUtil2['default'].getItemsMaxHeight(_this4.itemsInCart, index, _this4.scrolledToEnd);
            };

            this.getDetailsMaxHeight = function (index) {
                return _cartUiUtil2['default'].getDetailsMaxHeight(index);
            };

            this.getItemNameMaxHeight = function (index) {
                return _cartUiUtil2['default'].getItemNameMaxHeight(index);
            };

            this.tooLong = function (index, field) {
                if (field === 'name') {
                    _this4.itemsInCart[index].itemNameLong = true;
                } else if (field === 'number') {
                    _this4.itemsInCart[index].itemNumberLong = true;
                }
            };

            this.getContainerColWidth = function () {
                return _cartUiUtil2['default'].getContainerColWidth();
            };
        },
        populate: function populate() {
            var _this5 = this;

            if (this.stateChanged) {
                return;
            }
            $('#wrapper').addClass('cartBody');
            this.$on('$destroy', function () {
                $('#wrapper').removeClass('cartBody');
            });
            var memberCheckoutElement = document.getElementById('memberCheckout');
            var guestCheckoutElement = document.getElementById('guestCheckout');
            if (memberCheckoutElement) {
                memberCheckoutElement.appendChild(memberXOButtonScript);
            }
            if (guestCheckoutElement) {
                guestCheckoutElement.appendChild(guestXOButtonScript);
            }

            var buttonItemDetails = buttonParams && buttonParams.buttonItem;
            var merchantDetails = _cartUtil2['default'].getMerchantDetails(sCart, buttonItemDetails);
            _angular.$rootScope.$broadcast('merchantDetails', merchantDetails);

            _cartUiUtil2['default'].initWindowScrollActions();
            this.areAllItemsVisible = _cartUiUtil2['default'].areAllItemsVisible();
            _cartUiUtil2['default'].setOrderSummaryColor();
            this.expandSummary = this.itemsInCart && this.itemsInCart.length < 4;
            if (this.itemsInCart && this.itemsInCart.length >= 4 && !this.areAllItemsVisible) {
                $('#orderSummary').css('transform', 'translateY(' + Number($('.footer').prop('scrollHeight') + 1) + 'px)');
            }

            var itemsElement = document.getElementById('items');
            var scrollTopLimit = 999999;
            var scrolled = function scrolled() {
                if (_this5.itemsInCart && _this5.itemsInCart.length < 4) {
                    return;
                }
                // visible height + pixel scrolled = total height
                if (itemsElement.offsetHeight + itemsElement.scrollTop === itemsElement.scrollHeight) {
                    scrollTopLimit = itemsElement.scrollTop;
                    _this5.scrolledToEnd = true;
                    $('#orderSummary').removeClass('pushDown');
                    $('#orderSummary').css('transform', 'translateY(0)');
                    _this5.getItemsMaxHeight();
                } else if (itemsElement.scrollTop <= scrollTopLimit) {
                    _this5.scrolledToEnd = false;
                    $('#orderSummary').addClass('pushDown');
                    $('#orderSummary').css('transform', 'translateY(' + Number($('.footer').prop('scrollHeight') + 1) + 'px)');
                    _this5.getItemsMaxHeight();
                }
            };
            if (itemsElement) {
                itemsElement.onscroll = scrolled;
            }
            if (this.itemsInCart && this.itemsInCart.length < 4) {
                this.scrolledToEnd = true;
            }
            initiateUpdateQuantity = function initiateUpdateQuantity() {
                if (_this5.timer) {
                    _angular.$timeout.cancel(_this5.timer);
                }
                _this5.timer = (0, _angular.$timeout)(function () {
                    var cart = $.extend(true, {}, sCart);
                    cart.items = itemsToUpdate();
                    callUpdateCart(cart);
                }, 1000);
            };

            this.initiateUpdateQuantity = function (index) {
                cartItems[index].quantity = _this5.itemsInCart[index].quantity;
                initiateUpdateQuantity();
            };

            itemsToUpdate = function itemsToUpdate() {
                var items = [];
                _underscore2['default'].forEach(cartItems, function (item) {
                    if (!item.removed) {
                        if (item.quantity === '') {
                            item.quantity = 1;
                        }
                        items.push(item);
                    }
                });
                return items;
            };

            var insertXclickParamsInMayfly = function insertXclickParamsInMayfly() {
                checkoutXclickParam = _cartUtil2['default'].getParamsForCheckout(_squid.$meta.xclickParams);
                return _index.$ShoppingCartModel.instance(_squid.$meta.correlationId).action('insertMayflyData', {
                    data: checkoutXclickParam,
                    success: function success(result) {
                        return result && result.mayflyId;
                    },
                    error: function error(err) {
                        _logger.$logger.info('Insert_MayFly_Error', err.name);
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(errorName) {
                            _logger.$logger.info('Insert_MayFly_Error', errorName);
                        }
                    }
                });
            };

            var createSymphonyCartRequest = function createSymphonyCartRequest() {
                _cartUtil2['default'].removeHashKey(sCart);
                return _index2.$PPCartMapperModel.instance().action('getCartRequest', {
                    data: {
                        request: sCart,
                        flowLoggingId: _squid.$util.param('flowlogging_id')
                    },
                    success: function success(result) {
                        cartRequest = result;
                    },
                    error: function error(err) {
                        _logger.$logger.info('error', err.name);
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(errorName) {
                            _logger.$logger.info('ppcart_mapper_get_cart_request_error', errorName);
                            return fallback('wps', 'shoppingcart_checkout_fallback');
                        }
                    }
                });
            };

            var createSymphonyCart = function createSymphonyCart() {
                var cart = cartRequest;

                return _index2.$PPCartMapperModel.instance().action('createCart', {
                    data: {
                        request: cart,
                        flowLoggingId: _squid.$util.param('flowlogging_id')
                    },
                    success: function success(result) {
                        checkoutCartDetails = result;
                        _logger.$logger.info('checkoutCartId', checkoutCartDetails.cartId);
                    },
                    error: function error(err) {
                        _logger.$logger.info('error', err.name);
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(errorName) {
                            _logger.$logger.info('ppcart_mapper_create_cart_error', errorName);
                            return fallback('wps', 'shoppingcart_checkout_fallback');
                        }
                    }
                });
            };

            var checkInventory = function checkInventory() {
                var shoppingCart = cartRequest && cartRequest.cart;
                var purchaseUnit = shoppingCart && shoppingCart.purchase_units && shoppingCart.purchase_units[0];
                var items = purchaseUnit && purchaseUnit.item_list && purchaseUnit.item_list.items;
                var inventoryModel = _index4.$InventoryModel.instance(_squid.$meta.correlationId);
                return inventoryModel.action('getInventory', {
                    data: {
                        items: items,
                        merchantId: buttonParams.merchantId
                    },
                    success: function success(result) {
                        soldoutItems = undefined;
                        var isInventory = result.isInventory ? 1 : 0;
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'shoppingCart',
                            'to': 'check_inventory',
                            'is_inventory_enabled': isInventory
                        });
                        if (result.soldoutItems && result.soldoutItems.length > 0) {
                            soldoutItems = result.soldoutItems;
                            _angular.$rootScope.soldoutUrl = result.soldoutUrl;
                        }
                    },
                    error: function error(err) {
                        _logger.$logger.info('error', err.name);
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'shoppingCart',
                            'to': 'process_cart_creation',
                            'int_error_description': 'invetory_error',
                            'reason': 'CART_CREATION_FAILURE'
                        });
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('error', err.name);
                            _logger.$logger.info('checkout_fpti', {
                                'from': 'shoppingCart',
                                'to': 'process_cart_creation',
                                'int_error_description': 'invetory_error',
                                'reason': 'CART_CREATION_FAILURE'
                            });
                            return fallback('wps', 'shoppingcart_checkout_fallback');
                        }
                    }
                });
            };

            fallback = function fallback(product, reason) {
                throw new _squid.$FallbackError({
                    product: product || 'wps',
                    reason: reason
                });
            };

            prepareCheckout = function prepareCheckout(flow) {

                var redirectUrl = void 0;
                if (flow === 'member') {
                    _logger.$logger.info('checkout_type_member');
                    redirectUrl = _squid.$config.urls.hermesUrl;
                } else {
                    if (!_squid.$config.guestCheckoutEnabled) {
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'shoppingCart',
                            'to': 'prepare_guest_checkout',
                            'int_error_description': 'guest_checkout_disabled',
                            'reason': 'GUEST_CHECKOUT_DISABLED'
                        });
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    }
                    _logger.$logger.info('checkout_type_guest');
                    redirectUrl = _squid.$config.urls.xoonUrl;
                }
                var cart = $.extend(true, {}, sCart);
                cart.items = _cartUtil2['default'].getItemsForCheckout(cartItems);
                if (cart.items.length !== sCart.items.length) {
                    _this5.quantityChanged = true;
                }
                if (cart.items.length === 0) {
                    _logger.$logger.info('cart_empty');
                    return _angular.$q.all([callUpdateCart(cart)]).then(function () {
                        _this5.stateChanged = true;
                        _angular.$rootScope.continueShoppingUrl = _this5.continueShoppingUrl;
                        return _uiRouter.$state.go('checkout.emptyCart');
                    });
                } else {
                    return _angular.$q.all([callUpdateCart(cart)]).then(function () {
                        return createSymphonyCartRequest();
                    }).then(function () {
                        return checkInventory();
                    }).then(function () {
                        if (!soldoutItems) {
                            return createSymphonyCart();
                        }
                        return _angular.$q.when();
                    }).then(function () {
                        if (!soldoutItems) {
                            return insertXclickParamsInMayfly();
                        }
                        return _angular.$q.when();
                    }).then(function (mayflyId) {
                        if (soldoutItems) {
                            _logger.$logger.info('item(s)_sold_out');
                            var itemsSoldout = void 0,
                                count = void 0;
                            if ((typeof soldoutItems === 'undefined' ? 'undefined' : _typeof(soldoutItems)) === 'object') {
                                itemsSoldout = JSON.stringify(soldoutItems);
                                count = _this5.itemsInCart.length === soldoutItems.length ? 'all' : 'many';
                            } else {
                                itemsSoldout = soldoutItems;
                                count = 'one';
                            }
                            _this5.stateChanged = true;
                            return _uiRouter.$state.go('checkout.soldout', {
                                items: encodeURIComponent(itemsSoldout),
                                count: encodeURIComponent(count)
                            });
                        } else {
                            _logger.$logger.info('item(s)_available');
                            redirectUrl += checkoutCartDetails.cartId;
                            redirectUrl += '&xclick_params=' + ('' + checkoutXclickParam);
                            if (checkoutCartDetails.rm) {
                                redirectUrl += '&rm=' + ('' + checkoutCartDetails.rm);
                            }
                            if (mayflyId) {
                                redirectUrl += '&mfid=' + ('' + mayflyId);
                            }
                            redirectUrl += '&country.x=' + ('' + _squid.$locale.country);
                            redirectUrl += '&locale.x=' + (_squid.$locale.lang + '_' + _squid.$locale.country);
                            _squid.$util.redirect(redirectUrl);
                        }
                    });
                }
            };

            this.prepareCheckout = function (flow) {
                prepareCheckout(flow);
            };
        },
        exit: function exit() {
            angular.element('.merchantHeader').css('display', 'inherit');
            clearInterval(this.timer);
        }
    }
});


_angular.$timeout;

_angular.$q;

_angular.$rootScope;

_squid.$Component;

_squid.$config;

_squid.$util;

_squid.$meta;

_squid.$locale;

_squid.$FallbackError;

_uiRouter.$state;

_logger.$logger;

_index.$ShoppingCartModel;

_index2.$PPCartMapperModel;

_index3.$CartButtonParamsModel;

_index4.$InventoryModel;

_customUtil.customUtil;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shopping-cart/directive.js
// module id = ./pages/xo-shopping-cart/directive.js
// module chunks = 1